import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Loader } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useBusinessData as useWniBusinessData } from 'wni-portals-util-react';
import styles from './StatusComponent.module.scss';
import SubmissionIntakeUtil from './SubmissionIntakeUtil';
import SubmissionIntakeReview from './SubmissionIntakeReview';
import useWniModal from '../../hooks/ModalNext/useWniModal';

const StatusComponent = (props) => {
    const { 
        acrodReviewUrl, 
        submissionTokenId, 
        urlPrefix, 
        requireManualStatusCheck = false, 
        authdata = useAuthentication(),
        useBusinessData
    } = props;
    const { deploymentId, lifecycleserviceURL, getContinueStatus } = SubmissionIntakeUtil.getConfigs();
    const { submissionIntakeStatus, spreadSheetIntakeStatus } = getContinueStatus(useBusinessData || useWniBusinessData());
    const [ statusComplete, updateStatusComplete] = useState(false);
    const modalApi = useWniModal();
    const myHeaders = new Headers();
    const sigwrequestgrn = deploymentId;
    const siurl = lifecycleserviceURL;
    const token = authdata.accessToken;
    myHeaders.append('Authorization', `Bearer ${token}`);
    myHeaders.append('GW-Request-GRN', sigwrequestgrn);
    myHeaders.append('GW-User', authdata.userInfo.sub);

    let intervalCall;
    const getStatusSubmissionIntake = async () => {
        try {
            await fetch(
                `${siurl}/${submissionTokenId}/status`,
                {
                    method: 'GET',
                    headers: myHeaders
                }
            ).then((res) => {
                if (res.ok) {
                    return res.json();
                }
            }).then((jsondata) => {
                // OCRFinished / IntakeReconciliation => submission intake status
                // Filed / SSReconciliation / SSColumnMapping / SSHeaderSelection => spreadsheet intake status
                if (_.includes(submissionIntakeStatus, jsondata.status) || _.includes(spreadSheetIntakeStatus, jsondata.status)) {
                    updateStatusComplete(true);
                    // clean up
                    clearInterval(intervalCall);
                } else if (jsondata.status === "FilingFailed" || jsondata.status === "OCRFailed") {      
                    // clean up
                    clearInterval(intervalCall);          
                    return modalApi.showAlert({
                        title: 'ACORD Upload',
                        message: 'Something wrong with acord upload!',
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: "Ok"
                    }).then(() => {
                        window.location.reload();
                    })
                    .catch(_.noop);
                }
            })
        }
        catch (e) {
            // clean up
            clearInterval(intervalCall);
            return modalApi.showAlert({
                title: 'ACORD Upload',
                message: 'Something wrong with subIntake status API call!',
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: "Ok"
            }).then(() => {
                window.location.reload();
            })
            .catch(_.noop);
        }
    };

    useEffect(() => {
        intervalCall = setInterval(() => {
            getStatusSubmissionIntake();
        }, 500);
        return () => {
            // clean up
            clearInterval(intervalCall);
        };
    }, []);

    if (statusComplete) {
        return <SubmissionIntakeReview
            {...props}
            acrodReviewUrl={acrodReviewUrl}
            urlPrefix={urlPrefix}
            deploymentId={deploymentId}
            lifecycleserviceURL={lifecycleserviceURL}
            requireManualStatusCheck={requireManualStatusCheck}
            submissionTokenId={submissionTokenId}
            auth={authdata}
        />
    } 

    return (
        <div className={styles.UploadAcord}>
            <Loader customClass = "microApp"/>
        </div>
    );
};

export default withRouter(StatusComponent);
